import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePureComponent from 'react-immutable-pure-component'
import Layout from './layout'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import NewsFeedsPanel from '../components/panel/news_feeds_panel'
import ShortcutsPanel from '../components/panel/shortcuts_panel'

class NewsLayout extends ImmutablePureComponent {

  render() {
    const { children, title } = this.props

    const layout = [
      <ShortcutsPanel type='trends_rss' noPanel />,
      <NewsFeedsPanel noPanel />
    ]

    return (
      <Layout
        showBackBtn
        noRightSidebar
        showNormalSidebar
        page='news'
        title={title}
        search={{
          placeholder: 'Search links',
          to: '/search/links',
        }}
        sidebarChildren={<SidebarPanelGroup layout={layout} />}
      >
        {children}
      </Layout>
    )
  }

}

NewsLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
}

export default NewsLayout